import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef, useEffect } from 'react';
import { DEFAULT_COLOR_FILTERS } from 'commons/constants';
import ColorsFilter from 'components/essentials/ColorsFilter';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';
const ProductListingColorFilter = t0 => {
  const $ = _c(13);
  const {
    colors: t1,
    colorFilters,
    refineColorFilters,
    showAsTwoRows: t2
  } = t0;
  const colors = t1 === undefined ? DEFAULT_COLOR_FILTERS : t1;
  const showAsTwoRows = t2 === undefined ? false : t2;
  const {
    selectedColors,
    selectColor
  } = useAdvancedSearchContext();
  const pendingColorRef = useRef(null);
  let t3;
  if ($[0] !== selectColor) {
    t3 = () => {
      if (pendingColorRef.current !== null) {
        selectColor(pendingColorRef.current);
        pendingColorRef.current = null;
      }
    };
    $[0] = selectColor;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== colorFilters || $[3] !== selectColor) {
    t4 = [colorFilters, selectColor];
    $[2] = colorFilters;
    $[3] = selectColor;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== colorFilters || $[6] !== refineColorFilters) {
    t5 = colorLabel => {
      const matchedFilter = colorFilters.find(filter => filter.label.toLowerCase() === colorLabel.toLowerCase());
      if (matchedFilter) {
        pendingColorRef.current = colorLabel;
        refineColorFilters(matchedFilter.label);
      }
    };
    $[5] = colorFilters;
    $[6] = refineColorFilters;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleSelectColor = t5;
  if (!colors.length || !colors) {
    return null;
  }
  let t6;
  if ($[8] !== colors || $[9] !== handleSelectColor || $[10] !== selectedColors || $[11] !== showAsTwoRows) {
    t6 = <ColorsFilter colors={colors} onSelectColor={handleSelectColor} selectedColors={selectedColors} showAsTwoRows={showAsTwoRows} />;
    $[8] = colors;
    $[9] = handleSelectColor;
    $[10] = selectedColors;
    $[11] = showAsTwoRows;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default ProductListingColorFilter;